// RelVal weeks are keyed to Mondays, but source workbooks carry the date they
// were published on — Wells goes out on a Friday, the BAML series can run
// through mid-week. Uploaded values keep their own as-of date; this only
// offers the week's Monday alongside it in the date picker so the snapshot
// can be viewed or edited under either.

const MONDAY = 1;
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * The next Monday on or after `isoDate`. A date that is already a Monday is
 * returned unchanged. Non-ISO input is passed through so callers can hand
 * this whatever the parser produced.
 */
export const nextMonday = (isoDate) => {
  if (!ISO_DATE.test(String(isoDate || ""))) return isoDate;
  const date = new Date(`${isoDate}T00:00:00Z`);
  const daysToMonday = (MONDAY - date.getUTCDay() + 7) % 7;
  date.setUTCDate(date.getUTCDate() + daysToMonday);
  return date.toISOString().slice(0, 10);
};
